
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 80 58","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.385 6.105v33.58a18.263 18.263 0 01-5.414 12.944A18.557 18.557 0 0116.923 58a3.09 3.09 0 01-2.176-.894 3.04 3.04 0 01-.9-2.159c0-.81.323-1.586.9-2.158a3.09 3.09 0 012.176-.894 12.37 12.37 0 008.699-3.58 12.176 12.176 0 003.609-8.63v-3.053H6.154a6.186 6.186 0 01-4.35-1.79A6.088 6.088 0 010 30.525V6.106A6.088 6.088 0 011.804 1.79 6.186 6.186 0 016.154 0H29.23a6.186 6.186 0 014.35 1.79 6.088 6.088 0 011.804 4.315zM73.846 0H50.77a6.186 6.186 0 00-4.35 1.79 6.088 6.088 0 00-1.804 4.315v24.421a6.088 6.088 0 001.805 4.315 6.186 6.186 0 004.35 1.79h23.076v3.053a12.176 12.176 0 01-3.609 8.63 12.371 12.371 0 01-8.698 3.58 3.09 3.09 0 00-2.176.895 3.04 3.04 0 00-.901 2.158c0 .81.324 1.586.9 2.159a3.09 3.09 0 002.176.894 18.557 18.557 0 0013.049-5.37A18.264 18.264 0 0080 39.683V6.105a6.088 6.088 0 00-1.805-4.315A6.186 6.186 0 0073.846 0z","fill":"#F5D9BC"}})])
          )
        }
      }
    